import { render } from "./Integrated.vue?vue&type=template&id=13f7981d&scoped=true"
import script from "./Integrated.vue?vue&type=script&lang=js"
export * from "./Integrated.vue?vue&type=script&lang=js"

import "./Integrated.vue?vue&type=style&index=0&id=13f7981d&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f7981d"]])

export default __exports__